import React from 'react'

import { t } from '@insight/toolkit-utils'
import { Button } from '@insight/toolkit-react'

export default function Admin(props) {
  const { account, goToHashLink } = props
  const adminObject = [
    {
      title: account?.adminObj?.approvalManagement ? 'approvalManagement' : '',
      onClick: () => goToHashLink('/insightweb/ar/approvalpath'),
    },
    {
      title: account?.adminObj?.manageStandards ? 'manageStandards' : '',
      onClick: () => goToHashLink('/insightweb/search#manageStandards'),
    },
    {
      title: account?.adminObj?.manageStandardsNew ? 'manageStandards' : '',
      onClick: () => goToHashLink('/insightweb/standards-manager'),
    },
    {
      title: account?.adminObj?.stars ? 'stars' : '',
      onClick: () => goToHashLink('/insightweb/stars'),
    },
    {
      title: account?.adminObj?.userManagement ? 'userManagement' : '',
      onClick: () => goToHashLink('/insightweb/userManagement'),
    },
    {
      title: account?.adminObj?.roles ? 'roles' : '',
      onClick: () => goToHashLink('/insightweb/rolesAndPermissions'),
    },
  ]
  return adminObject.map((admin) => {
    if (admin?.title) {
      return (
        <li>
          <Button {...admin}>{t(admin.title)}</Button>
        </li>
      )
    }
  })
}
